module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"alt":{"logo":"%{user}のロゴ"}}}')
  delete Component.options._Ctor
}
